<template>
  <div>
    <div class="dialog-mask" v-show="objData.showDialog">
      <div class="dialog-box">
        <div class="dialog-title">公众号首页使用须知</div>
        <div class="dialog-body">
          <p>尊敬的家长们：</p>
          <p>欢迎您使用我们的公众号平台，为了帮助您更好地参与孩子的体育学习，我们特此发布以下使用须知，请您仔细阅读并遵守相关规定。</p>
          <p>一、学生绑定操作</p>
          <p>
            为了保障信息安全和隐私保护，家长在使用本平台前，需进行“学生绑定”操作。只有成功绑定的学生，家长才能查看到孩子的锻炼信息。请按照平台提示，正确填写学生的相关信息，并确保信息的准确性和完整性。
          </p>
          <p>二、信息安全与隐私保护</p>
          <p>我们非常重视用户信息的安全与隐私保护。在此郑重承诺，我们不存储学生照片等敏感信息。同时，我们将采取严格的技术和管理措施，确保学生信息的安全性和保密性。</p>
          <p>三、家校协同监督</p>
          <p>在运动家的支持下，我们致力于促进家校之间的紧密合作。通过本平台，家长可以实时了解孩子的体育学习情况，与学校共同监督体育家庭作业的完成情况，确保孩子在家中也能接受到科学、系统的锻炼指导。</p>
          <p>四、个性化运动分析与建议</p>
          <p>平台会根据学生的体测报告和锻炼报告，生成详尽的运动分析与个性化建议。这些建议旨在帮助家长和学生了解自身在运动中的优势与不足，为他们指明明确的锻炼方向，提高锻炼效果。</p>
          <p>五、遵守规定与文明使用</p>
          <p>在使用本平台时，请家长遵守相关规定，文明使用。不得发布不当言论、传播虚假信息或进行其他违规行为。对于违反规定的用户，我们将依法依规进行处理。</p>
          <p></p>
          <p></p>
          <p>
            <b>感谢您对我们公众号的信任与支持。我们将不断努力提升服务质量，为您提供更好的体验。如有任何疑问或建议，请随时联系我们。</b>
            <b>祝您和孩子在体育学习中取得更好的成绩！</b>
          </p>
        </div>
        <div class="dialog-btn-box">
          <van-button type="default" round @click="goNext()" :disabled="objData.num > 0">
            <van-checkbox v-model="objData.checked" :disabled="objData.num > 0" shape="square"><span
                v-if="objData.num > 0">({{ objData.num }})</span>我已阅读并同意</van-checkbox>
          </van-button>
          <!-- <van-button type="default" round @click="cancel()">取消</van-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "VDialog",
  props: {
    objData: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  created() { },
  methods: {
    goNext() {
      localStorage.setItem("isChecked", true);
      // Toast.loading({ message: "提交中..." });
      this.objData.showDialog = false;
      // this.$router.push("/myFitness");
    },
    cancel() {
      this.objData.showDialog = false;
      localStorage.removeItem("isChecked");
    },
    countdown() {
      const _this = this;
      const timeClock = setInterval(function () {
        _this.objData.num--;
        if (_this.objData.num === 0) {
          clearInterval(timeClock);
          _this.objData.checked = true;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.dialog-box {
  padding: 4vw;
  width: 80%;
  height: 60%;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2vw;
  font-size: 12px;
  overflow: scroll;
}

.dialog-title {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.dialog-body {
  padding: 2vw 0;
}

.dialog-body p {
  padding: 2vw 0;
}

.dialog-btn-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.dialog-btn {
  padding: 0 2vw;
  height: 10vw;
  line-height: 10vw;
  border-radius: 5vw;
  border: 1px solid #000000;
}

.confirmButton {
  color: #aaaaaa;
}

input {
  vertical-align: middle;
}
</style>
